<template>
  <div
    v-if="visible"
    class="Overlay"
    data-action="close-modal"
    @click.self="closeModal"
  >
    <div
      class="ModalBox ModalBox--central Modal--filters Modal--export"
      id="NewUserModal"
    >
      <div class="ModalBox-header d-flex d-md-flex justify-content-between align-items-center p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          <span v-t="{path : 'transactions_action_export'}"></span>
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>
        <div class="d-flex justify-content-between">
          <button
            class="Button Button--primary Button--s ml-auto hide-on-responsive"
            :disabled="downloadDisabled"
            :class="{'Button--primary--disabled' : downloadDisabled}"
            @click="exportBenefits"
          >
            <span class="Button-lit">{{$t(downloadButtonlabel)}}</span>
          </button>
        </div>
      </div>
      <div class="ModalBox-container px-3 pt-3">
        <div class="row d-flex justify-content-between p-3 h-100">
          <div class="input--block input--block--full">
            <label
              for=""
              class="form--label"
            >{{$t('benefits_export_benefits_select_period').toUpperCase()}}</label>
            <multiselect
              :options="benefitsPeriods"
              :selectLabel="''"
              :searchable="false"
              :customLabel="getDateCustomLabel"
              :allowEmpty="false"
              :showLabels="false"
              :selectedLabel="''"
              :openDirection="'below'"
              :placeholder="$t('benefits_export_select_period')"
              v-model="benefitsExportPeriod"
            >
              <div
                class="caret"
                slot="caret"
                slot-scope="{ toggle }"
                @mousedown.prevent.stop="toggle"
              >
                <i
                  class="Ctrl Ctrl--16"
                  aria-hidden="true"
                >
                  <svg
                    focusable="false"
                    aria-hidden="true"
                    aria-label="Edit"
                  >
                    <use xlink:href="#dropdown-icon"></use>
                  </svg>
                </i>
              </div>
              <template slot="noOptions">
                <span class="no-result">
                  {{ $t('multiselect_no_options_slot_default') }}
                </span>
              </template>

            </multiselect>
          </div>
          <div
            class="d-flex w-100 justify-content-center"
            v-if="isExporting"
          >
            <div class="d-flex flex-column align-items-center justify-content-center">
              <spinner></spinner>
              <small v-t.preserve="{path: 'ACTION_EXPORT_IN_PROGRESS'}"></small>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'

import Spinner from '@/components/Commons/Spinner'
import transactionsApi from '../../../transactions/_api/index'
import Multiselect from 'vue-multiselect'

import { segmentTrack } from '@/analytics/segment'
import { EXPORT_TRANSACTION_REPORT_EXTENSION } from '@/utils/constants'

export default {
  name: 'TransactionsExportModal',
  mixins: [_modalHandlerMixin],
  components: { Spinner, Multiselect },
  props: {
    defaultTab: {
      type: String,
      default: 'EXPORT'
    }
  },
  data () {
    return {
      minDate: '',
      maxDate: '',
      isExporting: false,
      benefitsExportPeriod: null,
      benefitsPeriods: []
    }
  },
  computed: {
    downloadDisabled () {
      return !this.benefitsExportPeriod
    },
    downloadButtonlabel () {
      return 'ACTION_DOWNLOAD'
    }
  },
  methods: {
    async exportBenefits () {
      if (this.isExporting) return
      try {
        this.isExporting = true
        const filters = {
          'date': this.benefitsExportPeriod.date
        }
        const response = await transactionsApi.getExportBenefitsTransactions(filters)
        const exportResult = URL.createObjectURL(response.data)
        let link = document.createElement('a')
        link.href = exportResult
        link.download = `Export_RF_y_BS_${this.$i18n.d(new Date(this.benefitsExportPeriod.date), 'month')}${EXPORT_TRANSACTION_REPORT_EXTENSION}`
        link.click()
        const startDate = this.$moment.utc(this.benefitsExportPeriod.flex_rem_start_date)
        const closureDate = this.$moment.utc(this.benefitsExportPeriod.flex_rem_closure_date)
        if (startDate && closureDate) {
          const daysInRange = closureDate.diff(startDate, 'days') + 1
          segmentTrack('User export benefit transactions', {
            days_in_range: daysInRange
          })
        }
        URL.revokeObjectURL(exportResult)
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'benefits_export_benefits_error' }, { root: true })
      } finally {
        this.isExporting = false
      }
    },
    async fetchBenefitsExportPeriods () {
      try {
        const { data } = await transactionsApi.getExportBenefitsTransactionsPeriods()
        this.benefitsPeriods = data
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'benefits_fetch_export_periods_error' }, { root: true })
      }
    },
    getDateCustomLabel (item) {
      if (item && item.date) {
        let formattedClosureDate = this.$moment.utc(item.flex_rem_closure_date).format()
        const month = this.$i18n.d(new Date(formattedClosureDate), 'month')
        const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1)
        return `${capitalizedMonth}`
      }
    }
  },
  async created () {
    await this.fetchBenefitsExportPeriods()
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.ModalBox.Modal--export {
  max-height: 623px;
  overflow: initial;
  .ModalBox-header {
    position: sticky;
  }
}
.Fuell-title-section {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-heading);
}
.Fuell-subtitle-section {
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
}
.Fuell-radio-container {
  margin-bottom: 4px;
  .Label {
    line-height: 14px;
  }
  label {
    padding: 0 !important;
  }
}
.export-warning {
  color: var(--gray);
  margin-left: 28px;
}
.link {
  color: var(--blue-action-1-active);
  text-decoration: underline;
  cursor: pointer;
}
.ModalBox {
  max-height: 835px;
  width: 800px;
  padding-left: 20px;
  padding-right: 20px;
  overflow: initial;
  padding-bottom: 20px;
}
.ModalBox--history {
  max-width: 850px;
  width: 100%;
}
.ModalBox-container {
  overflow: initial;
}
.ModalBox-header {
  position: initial;
}
.input--block {
  max-width: 368px;
}
.input--block--full {
  max-width: 100%;
}
.Checkbox-lit {
  font-weight: 300;
  font-size: 15px;
}
.help-text {
  color: var(--gray);
  font-weight: 300;
  font-size: 13px;
  margin-left: 24px;
  margin-top: -10px;
}

.remove-container {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.date-container > .Form-field {
  width: 100%;
}
.footer-responsive {
  display: none;
}

@media (max-width: 575px) {
  .input--block {
    width: 100%;
    max-width: 75vw;
  }
  .ModalBox {
    height: 100vh;
    max-height: 100vh;
    width: 100vw;
    max-width: 100vw;
    overflow-y: auto;
  }
  .Tabs {
    flex-direction: column;
    margin-bottom: 10px !important;
  }
  .hide-on-responsive {
    display: none;
  }
  .footer-responsive {
    display: block;
  }
  .Checkbox-customIcon {
    width: 20px;
  }
}
@media (min-width: 576px) and (max-width: 992px) {
  .input--block {
    max-width: 49%;
  }
}
</style>
